const formattersByLanguage = new Map<string, Intl.ListFormat>();

/**
 * Joins names the way the reader's language does, like "Nurse and Aide".
 * Formatters are cached because table cells call this for every row.
 */
export const formatNameList = (names: readonly string[], language: string): string => {
	let formatter = formattersByLanguage.get(language);
	if (!formatter) {
		formatter = new Intl.ListFormat(language, { style: "long", type: "conjunction" });
		formattersByLanguage.set(language, formatter);
	}
	return formatter.format(names);
};
